import { assignedDot, completedDot, verifiedDot } from "../assets";

// Stock status background color
export function getStockStatusBackground(status: string) {
  switch (status) {
    case "In Stock":
      return "#F4FFF2";
    case "Low Stock":
      return "#F2F7FF";
    case "Out of Stock":
      return "#FFFBF2";
    default:
      return "";
  }
}
// Stock status text color
export function getStockStatusTextColor(status: string) {
  switch (status) {
    case "In Stock":
      return "#016A1C";
    case "Low Stock":
      return "#003B8D";
    case "Out of Stock":
      return "#BA5900";
    default:
      return "";
  }
}

// Stock status dot
export function getStockStatusDotColor(status: string) {
  switch (status) {
    case "In Stock":
      return completedDot;
    case "Low Stock":
      return assignedDot;
    case "Out of Stock":
      return verifiedDot;
    default:
      return "";
  }
}

// Patient status background color
export function getPatientStatusBackground(status: string) {
  switch (status) {
    case "Discharged":
      return "#F4FFF2";
    case "Transferred to Basecamp":
      return "#FFFBF2";
    case "Transferred to Off Site":
      return "#F2F7FF";
    default:
      return "";
  }
}

// Patient status background color
export function getPatientStatusTextColor(status: string) {
  switch (status) {
    case "Discharged":
      return "#016A1C";
    case "Transferred to Basecamp":
      return "#BA5900";
    case "Transferred to Off Site":
      return "#003B8D";
    default:
      return "";
  }
}

// Patient status Dot
export function getPatientStatusDotColor(status: string) {
  switch (status) {
    case "Discharged":
      return completedDot;
    case "Transferred to Basecamp":
      return verifiedDot;
    case "Transferred to Off Site":
      return assignedDot;
    default:
      return "";
  }
}

// Patient List table status background color
export function getStatusBackground(status: string) {
  switch (status) {
    case "discharged":
      return "#E8F5E9";
    case "Transferred to Basecamp":
      return "#FFF3E0";
    case "transferOffProperty":
      return "#E3F2FD";
    case "Active":
      return "#E8F5E9";
    case "Visit Created":
      return "#E8F1FF";
    case "Reported":
      return "#FFFBF2";
    case "Draft":
      return "#FBE9E7"; // Light coral
    case "transferToClinic":
    case "Transfer to Clinic Location":
      return "#FFF3E0";
    case "transferToJHC":
    case "Transfer to JHC":
      return "#FFF3E0";
    case "InDisposition":
      return "#ededed";
    case "InInterval":
      return "#FFF3E0";
    case "Completed":
      return "#E8F5E9";
    case "In Progress":
      return "#FFF3E0";
    case "InReview":
      return "#E3F2FD";
    case "Pending":
      return "#FBE9E7";
    case "Under Review":
      return "#FBE9E7";
    case "Order Placed":
      return "#F4FFF2";
    case "In Stock":
      return "#F4FFF2";
    case "Low Stock":
      return "#FFFBF2";
    case "Out of Stock":
      return "#FFF2F3";
    case "Delivered":
      return "#F2F7FF";
    case "Re-Order":
      return "#F4FFF2";
    case "Cancelled":
      return "#FBE9E7"; // Light coral
    case "Under Review":
      return "#FFFBF2";
    case "Verified":
      return "#F2F7FF";
    default:
      return "#FFFFFF"; // Default white
  }
}

// Patient List table status text color
export function getStatusTextColor(status: string) {
  switch (status) {
    case "discharged":
      return "#016A1C";
    case "Transferred to Basecamp":
      return "#EF6C00";
    case "transferOffProperty":
      return "#1565C0"; // Dark blue
    case "Active":
      return "#016A1C";
    case "Visit Created":
      return "#0D47A1";
    case "Reported":
      return "#BA5900";
    case "Draft":
      return "rgb(167 47 10)";
    case "transferToClinic":
    case "Transfer to Clinic Location":
      return "#EF6C00";
    case "transferToJHC":
    case "Transfer to JHC":
      return "#EF6C00";
    case "InDisposition":
      return "#000000";
    case "InInterval":
      return "#EF6C00";
    case "Completed":
      return "#016A1C";
    case "In Progress":
      return "#EF6C00";
    case "InReview":
      return "#1565C0";
    case "Pending":
      return "rgb(167 47 10)";
    case "Under Review":
      return "rgb(167 47 10)";
    case "Order Placed":
      return "#016A1C";
    case "In Stock":
      return "#016A1C";
    case "Low Stock":
      return "#BA5900";
    case "Out of Stock":
      return "#B1000F";
    case "Delivered":
      return "#003B8D";
    case "Re-Order":
      return "#016A1C";
    case "Cancelled":
      return "rgb(167 47 10)"; // Light coral
    case "Under Review":
      return "#BA5900";
    case "Verified":
      return "#003B8D";
    default:
      return "#000000"; // Default black
  }
}

// Patient List table status dot color
export function getStatusDotColor(status: string) {
  switch (status) {
    case "discharged":
      return "#049B22"; // Green
    case "Transferred to Basecamp":
      return "#FF9800"; // Orange
    case "transferOffProperty":
      return "#2196F3"; // Blue
    case "Active":
      return "#049B22"; // Green
    case "Visit Created":
      return "#1976D2"; // Blue
    case "Reported":
      return "#BA5900"; // Orange
    case "Draft":
      return "rgb(167 47 10)"; // Red
    case "transferToClinic":
    case "Transfer to Clinic Location":
      return "#FF9800";
    case "transferToJHC":
    case "Transfer to JHC":
      return "#FF9800";
    case "InDisposition":
      return "#9E9E9E";
    case "InInterval":
      return "#FF9800";
    case "Completed":
      return "#049B22";
    case "In Progress":
      return "#FF9800";
    case "InReview":
      return "#2196F3";
    case "Pending":
      return "rgb(167 47 10)";
    case "Under Review":
      return "rgb(167 47 10)";
    case "Order Placed":
      return "#049B22";
    case "In Stock":
      return "#049B22";
    case "Low Stock":
      return "#D66F00";
    case "Out of Stock":
      return "#B1000F";
    case "Delivered":
      return "#004AB1";
    case "Re-Order":
      return "#049B22";
    case "Cancelled":
      return "rgb(167 47 10)"; // Light coral
    case "Under Review":
      return "#D66F00";
    case "Verified":
      return "#004AB1";
    default:
      return "#9E9E9E"; // Default gray
  }
}

export const destructStatusData = (status: string) => {
  switch (status) {
    case "Active":
      return "New Patient";
    case "transferOffProperty":
      return "Transfer Off Property";
    case "discharged":
      return "Discharged";
    case "transferToJHC":
    case "Transfer to JHC":
      return "Expected";
    case "InDisposition":
      return "In Disposition";
    case "InInterval":
      return "Interval";
    case "transferToClinic":
    case "Transfer to Clinic Location":
      return "Observation";
    case "Completed":
      return "Completed";
    case "In Progress":
      return "In Progress";
    case "InReview":
      return "In Review";
    case "Pending":
      return "Pending";
    case "Under Review":
      return "Under Review";
    case "Order Placed":
      return "Order Placed";
    case "In Stock":
      return "In Stock";
    case "Low Stock":
      return "Low Stock";
    case "Out of Stock":
      return "Out of Stock";
    case "Delivered":
      return "Delivered";
    case "Cancelled":
      return "Cancelled";
    case "Re-Order":
      return "Re-Order";

    default:
      return status;
  }
};

// Unsigned Visits table Signed/Unsigned dot color
// status: true => Signed, false => Unsigned, "na" => no visit note (neutral gray)
export const getSignTextColor = (status: any) =>
  status === "na" ? "#6B7280" : status ? "#016A1C" : "#B1000F"; // Gray / Green / Red
export const getSignBackground = (status: any) =>
  status === "na" ? "#F3F4F6" : status ? "#F4FFF2" : "#FFF2F3"; // Light Gray/Green/Red
export const getSignDotColor = (status: any) =>
  status === "na" ? "#9CA3AF" : status ? "#049B22" : "#B1000F"; // Matching dot color
